__webpack_require__.p = "/inventory/";